import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Select,
  Image,
  Table,
  Input,
  Modal,
  notification,
} from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { GreenNotify, RedNotify } from "../../helper/helper";
import SubCategory from "../../components/updateSubCategory/updateSubCategory";
import { homeIcon } from "../../assets";

const Organizers = () => {
  const [subCategories, setSubCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddSubCategoryModalVisible, setIsAddSubCategoryModalVisible] =
    useState(false);
  const [expandedDescription, setExpandedDescription] = useState(null);

  const getAllSubCategories = () => {
    callApi("GET", routes.getSubCategories, null, setIsLoading, (res) => {
      setSubCategories(res?.data?.categories || []);
    });
  };

  useEffect(() => {
    getAllSubCategories();
  }, []);
  const showFullDescription = (text) => {
    Modal.info({
      title: "Description",
      content: (
        <div>
          <p style={{ textAlign: "justify" }}>{text}</p>
        </div>
      ),
      onOk() {},
    });
  };
  const handleDelete = (recordId) => {
    callApi(
      "DELETE",
      `${routes.deleteSubCategorie}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          setSubCategories((prevSubCate) =>
            prevSubCate.filter((sub) => sub._id !== recordId)
          );
          GreenNotify("Sub Category Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting stage");
        }
      },
      (error) => {
        notification.error({
          message: "Error",
          description: "An error occurred while deleting the stage.",
        });
      }
    );
  };

  const handleAddYoga = () => {
    setUpdateRecordData(null);
    setIsAddSubCategoryModalVisible(true);
  };

  const handleEditYoga = (recordId) => {
    const selectedSubCategory = subCategories.find(
      (cat) => cat._id === recordId
    );
    setUpdateRecordData(selectedSubCategory);
    setIsAddSubCategoryModalVisible(true);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Content",
      dataIndex: "content",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          {expandedDescription === record.key ? (
            <span>{text}</span>
          ) : (
            <div>
              <span>{`${text.slice(0, 50)}...`}</span>
              <Button type="link" onClick={() => showFullDescription(text)}>
                See More
              </Button>
            </div>
          )}
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "_id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div style={{ whiteSpace: "nowrap" }}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditYoga(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ marginRight: 8 }}
          ></Button>
        </div>
      ),
      width: "auto",
    },
  ];

  const data = subCategories
    ?.map((item, index) => ({
      key: index,
      _id: item?._id,
      title: item?.title,
      content: item?.content,
    }))
    .filter((item) =>
      item?.title?.toLowerCase().includes(searchText.toLowerCase())
    );

  const getRowClassName = (record, index) =>
    index % 2 === 0 ? "server-role-even-row" : "server-role-odd-row";

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isLoading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Sub Categories</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Sub Categories</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAddYoga}
        style={{ marginBottom: "16px" }}
      >
        Add Sub Category
      </Button>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>

      <SubCategory
        visible={isAddSubCategoryModalVisible}
        toggleModal={() => {
          setIsAddSubCategoryModalVisible(false);
          getAllSubCategories();
        }}
        recordData={updateRecordData}
      />
    </div>
  );
};

export default Organizers;
